import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewRef
} from '@angular/core';
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {LoadingService} from "../../../services/LoadingService";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {takeUntil} from "rxjs/operators";
import {CollaborationService} from "../../../services/Collaboration.service";
import {ToastService} from "../../../services/Toast.service";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {Session} from "../../../services/Session";
import {CollaborationCacheService} from "../../../services/collaboration-cache.service";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import FroalaEditor from 'froala-editor';
import {LabelInputSearchComponent} from "../label-input-search/label-input-search.component";
import {ClickOutsideDirective} from "../../../directives/click.outside";
import { environment } from '../../../../environments/environment';

declare const _: any;
declare const jQuery: any;

@Component({
  selector: 'app-new-comment',
  standalone: true,
  imports: [CommonModule, FormsModule, FileUploadModule, FroalaEditorModule, FroalaViewModule, LabelInputSearchComponent, ClickOutsideDirective],
  templateUrl: './new-comment.component.html',
  styleUrl: './new-comment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewCommentComponent implements OnInit, OnDestroy {
  @Input() org: string;
  @Input() user: any;
  @Input() post: any;
  @Input() postId: string;
  @Input() taskId: string;
  @Input() pageType: string;
  @Input() channelType: string;
  @Input() companyId: string;
  @Input() draftMessage: string;
  @Input() collaborationAccess: boolean;
  @Input() displayType: any;
  @Input() clientInternalUsers: any;

  @Output() onDeleteAttachment: EventEmitter<string> = new EventEmitter<string>();
  @Output() onOpenDocument: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRefreshPost: EventEmitter<void> = new EventEmitter<void>();

  pdfLink: string;
  postUploadResp: Array<any> = [];
  uploader: any;
  generatedId: string;
  uploadCount = 0;
  reveal: any = {
    onMove: false,
    documentUpload: false,
    mailAttach: false
  };
  id: string = this.guid();
  newCommentMessage = '';
  messageHeight = true;
  searchString: boolean;
  mentionIds: Array<any> = [];
  suggestions: Array<any> = [];
  users: Array<any> = [];
  allUsers: Array<any> = [];
  uploadingDocumentName: string;
  showMentionDropdown = false;
  mentions: Array<any> = [];
  isCustomer = false;
  mentionUsers: Array<any> = [];
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  toggledGiphy = false;
  isGify = false;
  gifyUrl: any;
  editor: any;
  editorOptions: any = {
    listAdvancedTypes: false,
    linkAlwaysBlank: true,
    toolbarInline: true,
    enter: FroalaEditor.ENTER_DIV,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    imageUploadRemoteUrls: false,
    events: {
      initialized: (e) => {
        this.editor = e.getEditor();
        this.editor.events.on('keydown', (keydownEvent: any) => {
          if (!keydownEvent.shiftKey && keydownEvent.keyCode === 13) {
            this.onCommentEnter(keydownEvent);
          }
        }, true);

        this.editor.events.on('keyup', (keyupEvent: any) => {
          if (keyupEvent && keyupEvent.target.innerHTML) {
            const obj = {
              newMessage: keyupEvent.target.innerHTML
            };
            this.cacheService.insertStoreCache(this.post.id, obj);
          }
        }, true);

        this.editor.events.on('drop', (dropEvent: any) => {
          dropEvent.preventDefault();
          return false;
        }, true);

        this.editor.events.on('image.beforePasteUpload', (img) => {
          const base64 = img.getAttribute('src');
          const arr = base64.split(',');
          const mime = arr[0].match(/:(.*?);/)[1];
          const exactMime = mime.split('/')[1];
          const imageName = 'image_' + Math.floor((Math.random() * 100) + 1) + '.' + exactMime;
          const base = this;
          this.urltoFile(base64, imageName, mime)
            .then((file: any) => {
              const files: any = [];
              files.push(file);
              base.uploader.addToQueue(files);
              base.startUpload(img, base.post.id);
            });
          this.editor.html.set(base.newCommentMessage);
          return false;
        }, true);
      },
    },
    toolbarButtons: ['bold', 'italic', 'underline', 'textColor', 'backgroundColor', 'formatOL', 'formatUL', 'quote', 'insertLink'],
    charCounterCount: false,
    quickInsertTags: [],
    zIndex: 1,
    theme: 'royal'
  };
  documentsIds: Array<any> = [];
  documentsData: Array<any> = [];
  docData: Array<any> = [];
  constructor(
    private collaborationService: CollaborationService,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private changeDetectorRef: ChangeDetectorRef,
    private cacheService: CollaborationCacheService,
    private switchBoard: SwitchBoard,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this._init();
  }

  _init() {
    this.users = Session.getUsers() || [];
    const user: any = Session.getUser();
    this.generatedId = this.guid();
    this.isCustomer = user.isCustomer;
    if (this.draftMessage) {
      this.newCommentMessage = this.draftMessage;
    }
    this.editorOptions.placeholderText = this.post.taskId ? 'Make a note...' : 'Write a comment...';
    this.uploaderUpdate();
    this.buildItemForm();

    this.switchBoard.onRevealClose.pipe(takeUntil(this.destroy$)).subscribe(next => {
      this.docData = [];
      this.documentsIds = [];
      this.documentsData = [];
    });
  }

  deleteAttachment(attachmentId) {
    this.onDeleteAttachment.emit(attachmentId);
    _.remove(this.postUploadResp, {id: attachmentId});
  }

  stopPropagation($event) {
    $event && $event.stopImmediatePropagation();
  }

  onCommentEnter(event) {
    const base = this;
    if (this.postUploadResp.length > 0 || event.target.innerText.length > 0) {
      const message = event.target.innerText;
      const htmlMessage = event.target.innerHTML;
      this.processComment(message, htmlMessage);
      event.target.innerText = '';
    }
  }

  processComment(message, htmlMessage) {
    const base = this;
    try {
      let newComment: any = {
        user: {
          firstName: this.user.first_name,
          lastName: this.user.last_name,
          id: this.user.id,
          colorCode: this.user.colorCode,
          bot: false,
          thumbnail: this.user?.thumbnail?.length > 0 ? this.user.thumbnail : '',
        },
        orgId: Session.getOrg(),
        commentedBy: this.user.id,
        message,
        html_message: htmlMessage,
        postID: this.postId,
        postInternal: this.post.internal,
        postEntityType: this.post.entityType,
        postEntityId: this.post.entityID,
        children: [],
        browserTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        documents: [],
        mentionIds: []
      };
      if (this.postUploadResp.length > 0) {
        for (const i in this.postUploadResp) {
          const obj = {
            name: this.postUploadResp[i].name,
            id: this.postUploadResp[i].id,
            temporaryURL: this.postUploadResp[i].temporaryURL,
            doc_notes: this.postUploadResp[i].documentNotes
              ? this.postUploadResp[i].documentNotes
              : ''
          };
          newComment.documents = [...newComment.documents, obj];
        }
        newComment = {...newComment, id: this.postUploadResp[0].sourceID};
      } else {
        newComment = {...newComment, id: this.guid()};
      }
      if (this.documentsIds.length > 0) {
        newComment.documents = [...newComment.documents, ...this.documentsIds];
      }
      if (this.post.comments) {
        if (this.channelType === 'orgs') {
          console.log('before org post comments length', this.post.comments.length);
        }
        if (this.post.taskId) {
          this.post.comments.unshift(newComment);
        } else {
          this.post.comments.push(newComment);
        }
        if (this.channelType === 'orgs') {
          console.log('updated comment to  org push comments length', this.post.comments.length);
        }
      } else {
        this.post.comments = [];
        this.post.comments.push(newComment);
      }
      this.onRefreshPost.emit();
      base.isGify = false;
      this.prependMentions(newComment);
      this.resetNewCommentField();
      this.collaborationService
        .createComment(this.org, this.channelType, newComment, this.companyId, this.postId, this.taskId)
        .subscribe(
          response => {
            this.handleCommentCreation(response);
          },
          error => {
            this.handleCommentCreationFailure(error);
          }
        );
    } catch (e) {
      console.log('error while onCommentEnter', e);
    }
  }

  handleCommentCreationFailure(error) {
    this.postUploadResp = [];
    this.docData = [];
    this.documentsData = [];
    this.documentsIds = [];
    this.post.comments.splice(-1, 1);
    this.toastService.pop(
      TOAST_TYPE.error,
      'Failed To Post'
    );
    this.onRefreshPost.emit();
  }

  handleCommentCreation(response) {
    const responseObj = response;
    const index = _.findIndex(this.post.comments, function(comment) {
      return comment.id === responseObj.id;
    });
    this.draftMessage = '';
    this.post.draft = {};
    this.cacheService.removeStoreCache(this.post.id);
    if (index != -1) {
      this.post.comments[index] = responseObj;
    }
    this.resetUploader();
    this.docData = [];
    this.documentsData = [];
    this.documentsIds = [];
    this.onRefreshPost.emit();
  }

  resetNewCommentField() {
    this.messageHeight = false;
    this.newCommentMessage = '';
    this.mentionIds = [];
    this.mentions = [];
    this.allUsers = [];
    this.postUploadResp = [];
    this.gifyUrl = '';
    this.docData = [];
    this.documentsData = [];
    this.documentsIds = [];
    setTimeout(() => {
      this.messageHeight = true;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  guid() {
    return (
      this.s4() +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      this.s4() +
      this.s4()
    );
  }

  resetUploader() {
    this.uploader.queue.forEach(function(item) {
      item.remove();
    });
  }

  startUpload(type, id?: string) {
    const base = this;
    if (this.uploader.queue.length > 1) {
      setTimeout(() => {
        base.uploader.uploadAll();
      }, 400);
    } else {
      this.uploader.queue.forEach(function(item) {
        base.uploadingDocumentName = item.file.name;
      });
      this.uploadDocument();
      setTimeout(() => {

        if (!(this.changeDetectorRef as ViewRef).destroyed) {
          this.changeDetectorRef.detectChanges();
        }
      }, 400);

    }
  }

  buildItemForm() {
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.generatedId ? this.generatedId : this.guid();
      payload.sourceType = (this.channelType == 'orgs') ? 'BROADCAST_POST_COMMENT' : 'TODO_POST_COMMENT';
      form.append('payload', JSON.stringify(payload));
    };
    this.postUploadResp = [];
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploadCount++;
        this.postUploadResp = [...this.postUploadResp, JSON.parse(response)];
        this.uploader.progress = 100;
        if (this.uploader.queue.length === this.uploadCount) {
          this.toastService.pop(TOAST_TYPE.success, 'Uploaded Successfully');
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
          if (!(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.detectChanges();
          }
        } else {
          this.toastService.pop(
            TOAST_TYPE.success,
            this.uploadCount +
            '/' +
            this.uploader.queue.length +
            ' Uploaded Successfully'
          );
          if (!(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.detectChanges();
          }
          this.loadingService.triggerLoadingEvent(false);
        }
      } else {
        this.toastService.pop(TOAST_TYPE.error, 'Error While Uploading');
        this.uploadCount++;
        if (this.uploader.queue.length === this.uploadCount) {
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
        }
      }
    };
  }

  uploaderUpdate() {
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, Session.getUser().id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [
        {
          name: 'Authorization',
          value: 'Bearer ' + Session.getToken()
        }
      ]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  uploadDocument() {
    const base = this;
    this.uploader.queue.forEach(function(item) {
      item.file.name = base.uploadingDocumentName;
    });
    this.uploader.uploadAll();
    this.loadingService.triggerLoadingEvent(true);
  }

  downloadDocument(id, type) {
    this.collaborationService
      .getDocument(this.channelType, id, this.companyId)
      .subscribe(
        response => {
          if (type === 'download') {
            window.open(response.temporaryURL);
          } else {
            let link = response.viewDocContentURL;
            if (
              response.name.indexOf('.pdf') !== -1 ||
              response.name.indexOf('.docx') !== -1
            ) {
              link =
                'https://drive.google.com/viewerng/viewer?url=' +
                encodeURIComponent(link);
            }
            window.open(link);
          }
        },
        error => {
        }
      );
  }

  openImage(attachment) {
    const baseUrl = 'https://documents.taxplaniq.com/' + attachment.id;
    this.onOpenDocument.emit({
      isImageType: true,
      isPdf: false,
      selectedImage: baseUrl,
      pdfLink: this.pdfLink
    });
  }

  prependMentions(newComment) {
    const base = this;
    if (this.mentionIds.length > 0) {
      if (this.mentionIds[0].id == 'All') {
        this.mentionIds = [...this.allUsers];
      }
      const mentionString = _.map(this.mentionIds, function(mention) {
        return `@${mention.name}`;
      });
      newComment.mention_message = `${mentionString}:`;
      if (this.pageType == 'teams') {
        newComment.mentionIds = _.map(this.mentionIds, 'userId');
      } else {
        newComment.mentionIds = _.map(this.mentionIds, 'id');
      }
    }
  }

  showMentionWidget() {
    this.allUsers = [...this.users];
    this.mentionUsers = [...this.users];
    this.mentionUsers.unshift({id: 'All', name: 'All'});
    setTimeout(() => {
      this.showMentionDropdown = true;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  closeMentionContainer() {
    this.showMentionDropdown = false;
  }

  mentionSelected($event) {
    if ($event && $event.id == 'All') {
      this.mentionIds = [{id: 'All', name: 'All'}];
      this.mentions = ['All'];
    } else if ($event) {
      const index = _.findIndex(this.mentionIds, {id: $event.id});
      if (index == -1) {
        this.mentionIds = [...this.mentionIds, $event];
        this.mentions = _.map(this.mentionIds, 'name');
      }
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  removeMention($event) {
    if ($event && $event.id == 'All') {
      this.mentionIds = [];
      this.mentions = _.map(this.mentionIds, 'name');
    } else if ($event) {
      const index = _.findIndex(this.mentionIds, {id: $event.id});
      if (index !== -1) {
        this.mentionIds = this.mentionIds.filter((entry, idx) => {
          return index != idx;
        });
      }
      this.mentions = _.map(this.mentionIds, 'name');
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  triggerFileUpload() {
    jQuery('#comment-' + this.post.id).click();
  }

  urltoFile(url, filename, mimeType) {
    return (fetch(url)
        .then(function(res) {
          return res.arrayBuffer();
        })
        .then(function(buf) {
          return new File([buf], filename, {type: mimeType});
        })
    );
  }

  openGiphy() {
    setTimeout(() => {
      this.toggledGiphy = true;
      this.changeDetectorRef.detectChanges();
    });
  }

  closeHandleContainer() {
    this.toggledGiphy = false;
    this.invokeChangeDetection();
  }

  invokeChangeDetection() {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  handleGiphySelection(event) {
    this.isGify = true;
    this.gifyUrl = event.url;
  }

  removeGiphy(gify) {
    gify = '';
    this.gifyUrl = '';
    this.isGify = false;
  }

  updateStoreMessage($event) {
    if ($event && $event.target.innerHTML) {
      const obj = {
        newMessage: $event.target.innerHTML
      };
      this.cacheService.insertStoreCache(this.post.id, obj);
    }
  }

  openDocReveal() {
    setTimeout(() => {
      this.reveal = {...this.reveal, mailAttach: true};
      this.changeDetectorRef.detectChanges();
    });
  }

  removeDocument(doc) {
    const base = this;
    for (let i = 0; i < base.documentsData.length; i++) {
      if (base.documentsData[i].id === doc.id) {
        base.documentsIds.splice(i, 1);
        base.documentsData.splice(i, 1);
      }
    }
  }

  attachFromDocs(document) {
    this.docData = document.documentsData;
    for (let i = 0; i < this.docData.length; i++) {
      this.documentsData.push(this.docData[i]);
      const obj = {
        id: this.docData[i].file.id,
        name: this.docData[i].file.name,
      };
      this.documentsIds.push(obj);
    }
  }

}
